<template>
  <div :class="classes">
    <slot v-if='!variableMode' class='flex-1' name="default">
      <numberer v-model='dummy' @change='onChange' />
    </slot>
    <select-variable v-else class="flex-1" v-model='cheese' :variables='variables' />
    <toggle-switch v-if='isAdvancedMode' v-model='variableMode' class="py-1 flex-none" :label='null'>
      <template #off="{}">
        <numeric class="text-black" />
      </template>
      <template #on="{}">
        <variable class="text-black" />
      </template>
    </toggle-switch>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { isObject } from 'lodash';
import Numberer from '@ui/atoms/Numberer.vue';
import ToggleSwitch from '@ui/atoms/ToggleSwitch.vue';
import SelectVariable from '@ui/molecules/SelectVariable.vue';
import Numeric from '@icons/Numeric.vue';
import Variable from '@icons/Variable.vue';
export default {
  props:{
    value:{
      type:[Number, Boolean, String, Object],
      required:false
    },
    type:{
      type:String,
      default() {
        return 'number';
      }
    },
    variables:{
      type:Array,
      required:true
    },
    togglePosition:{
      type:String,
      default:'row'
    }
  },
  components:{
    SelectVariable,
    Variable,
    Numeric
  },
  data() {
    const variableMode = (isObject(this.value) && this.value.type === 'variable');
    return {
      variableMode,
      dummy:this.value,
      cheese:this.value
    }
  },
  methods:{
    onChange() {
      this.$emit("change",  this.value);
    }
  },
  watch:{
    value(nv, ov) {
      const variableMode = (isObject(this.value) && this.value.type === 'variable');
      this.variableMode = variableMode;
      this.dummy = nv;
    },
    dummy(nv) {
      this.$emit("input", nv);
    },
    cheese(nv) {
      console.log('cheese is', nv);
      this.$emit("input", {
        type:'variable',
        name:nv.name,
        id:nv.id
      });
    },
    variableMode(nv) {
      if (typeof(nv) === 'undefined') {
        if (this.type === 'number') {
          this.$emit('input', 1);
        } else {
          this.$emit('input', '');
        }
        
      }
    }
  },
  computed:{
    classes() {
      const classes = ['max-w-xs','md:max-w-md', 'h-full'];
      if (this.togglePosition === 'col') {
        classes.push('flex');
        classes.push('flex-row');
      } else {
      }
      return classes;
    },
    ...mapState(['isAdvancedMode'])

 }
}
</script>
